import axios from "../../../context/axiosConfig";

const pozyczkiImportXml = async ({ xmlContent, user }) => {
	return axios.post("/pozyczki/import/xml", {
		xmlContent,
		user,
	});
};

export default pozyczkiImportXml;
